import KonfigurasiAuth from "../../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigAuthTeacher"
export default function Home() {
  
  return (
    <KonfigurasiAuth />
  );
}
